import api from '../../../utils/api';

export interface AdmissionStage {
  id: number;
  stageOrder: number;
  stageName: string;
  requiredRole: string;
  actionLabel: string;
  rejectLabel: string;
  isFinalStage: boolean;
  hasUsersAssigned: boolean;
}

export interface AdmissionStagePayload {
  stageOrder: number;
  stageName: string;
  requiredRole: string;
  actionLabel: string;
  rejectLabel: string;
  isFinalStage: boolean;
}

export const getAdmissionStages = async () => {
  return (await api.get('/admission-approval/stages'))?.data as APIResponse<AdmissionStage[]>;
};

export const configureAdmissionStages = async (payload: AdmissionStagePayload[]) => {
  return (await api.post('/admission-approval/stages/configure', payload))?.data as APIResponse<any>;
};
